import { Stack } from "@mui/material";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import type { CreateIntervalFormData } from "@sinch/components/application/RateInterval/CreateInterval/formSchema";
import { CheckboxInput } from "@sinch/components/form/CheckboxInput/CheckboxInput";
import { useMuiController } from "@sinch/components/index";

export const CzechHolidaysSettings: FC = () => {
  const { t } = useTranslation();
  const { field: saturdayField } = useMuiController<CreateIntervalFormData, "settings.includeSaturday">({
    name: "settings.includeSaturday",
  });
  const { field: sundayField } = useMuiController<CreateIntervalFormData, "settings.includeSunday">({
    name: "settings.includeSunday",
  });

  return (
    <Stack spacing={2}>
      <CheckboxInput {...saturdayField} checked={saturdayField.value} label={t("RateUnit.includeSaturdays")} />
      <CheckboxInput {...sundayField} checked={sundayField.value} label={t("RateUnit.includeSundays")} />
    </Stack>
  );
};
